import React from 'react';

const ToggleSwitch = ({ checked, onChange, label = "Show Other People If I Run Out" }) => {
  return (
    <div className="toggle-switch-container">
      <div className="toggle-switch">
        <input
          type="checkbox"
          id="show-others-toggle"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="toggle-slider"></span>
      </div>
      <label htmlFor="show-others-toggle" className="toggle-switch-label">
        {label}
      </label>
    </div>
  );
};

export default ToggleSwitch;
